<template>
	<v-navigation-drawer  
      	clickep permanent dark hide-overlay
      	v-model="open.sidebar"      	
      	width="300"
      	class="fill-height" 
      	:height="currentHeight"
      	:mini-variant.sync="mini"
    >
      	<!-- :value="true" -->
    	<!-- <v-toolbar>
    		<v-toolbar-title>
    			{{ $ml.get('tags') }}
    		</v-toolbar-title>
    	</v-toolbar> -->
    	<v-list-item class="px-2">
	        <v-list-item-avatar>
	          	<v-icon>mdi-dots-vertical</v-icon>
	        </v-list-item-avatar>
	        <v-list-item-title>{{$ml.get('options')}}</v-list-item-title>

	        <v-btn icon @click.stop="toggleMini()">
	          	<v-icon>{{!mini?'mdi-chevron-left':'mdi-chevron-right'}}</v-icon>
	        </v-btn>
	    </v-list-item>
	    <v-list dense>
		    <v-list-group
		        v-for="(item,idx) in panelItems"
		        :key="idx+'panel'"
		        v-model="item.active"
		        :prepend-icon="item.icon"
		        no-action
		      >
		        <template v-slot:activator>
		          <v-list-item-content>
		            <v-list-item-title v-text="$ml.get(item.title)"></v-list-item-title>
		          </v-list-item-content>
		        </template>
	        	<component :is="item.component" :infoToFilter="infoToFilter" :open="open" ></component>
		    </v-list-group>
		</v-list>    
		<v-list-item class="px-2">
			<v-divider></v-divider>
	        <v-list-item-title >
	        	<v-btn color="primary" block @click="search()" :loading="loading" :disabled="isFilterEnable" hint="Required faces and video" hint-pesistent> {{ $ml.get('search')}}</v-btn>
	        </v-list-item-title>
	    </v-list-item>	  	
    </v-navigation-drawer>
</template>
<script type="text/javascript">
	import SidebarFaces from "@/components/face/SidebarFaces.vue"
	import SidebarVideoDatabase from "@/components/face/SidebarVideoDatabase.vue"
	import SidebarDevices from "@/components/face/SidebarDevices.vue"
	import SidebarListFaces from "@/components/face/SidebarListFaces.vue"

	// import testResult from "@/components/tester/test_video_by_search_results.js"
	export default{
		name : "SidebarSearchByVideo",
		props : ["open","infoToFilter","currentHeight"],
		components: { SidebarFaces, SidebarVideoDatabase, SidebarDevices, SidebarListFaces},
		data : ()=>({
			loading: false,
			panel:[0,1,2],
			panelItems:[
				{ title: "faces", component:"SidebarFaces", icon:"mdi-face"},
				{ title: "list", component:"SidebarListFaces", icon:"mdi-file"},
				{ title: "video_database", component:"SidebarVideoDatabase", icon:"mdi-video"},
				// { title: "devices", component:"SidebarDevices", icon:"mdi-devices"},
			],
			mini : false,
			// test: testResult,
		}),
		computed:{
			isFilterEnable(){
				// console.log( "check " , this.infoToFilter.faceListSelecteds.length)
				return ((this.infoToFilter?.tags?.length && this.infoToFilter?.tagsSelected.length) 
					|| (this.infoToFilter?.videos?.length && this.infoToFilter.faceListSelecteds.length)) 
					&& (this.infoToFilter.videosSelected || this.infoToFilter.deviceSelecteds.length) ? false : true;
			},			
		},
		mounted(){
			
		},
		methods:{
			toggleMini() {
				this.open.sidebar = !this.open.sidebar;
			    this.mini = !this.mini;
			},
			async search(){
				try{
					// this.renderTest()
					// return 

					this.loading=true;
					this.infoToFilter.loadingVideo=true;
					let info_up= {uuid:[], faces:[]};
					/*"uuid": [
					    {
					      type:"videodb",
					      uuid:""
					    },
					    {
					      type:"device",
					      uuid:"",
					      interval:[star,end]
					    },
					 ],
					 "faces": [
					   {
					     "path": "/opt/alice-media/john_photo.jpeg",
					     "photo_uuid": "photo1",
					     "top_n": 5
					   },
					   
					 ]*/
					if(this.infoToFilter.tagsSelected && this.infoToFilter.tagsSelected.length){
						info_up.faces=this.infoToFilter.tagsSelected.map((x,idx)=> {
							return {
								path : x.path || x.imgBase64,
								photo_uuid : x.uuid,
					     		top_n: idx,
					     		name : x.name,
							}
						})
					}
					if(this.infoToFilter.faceListSelecteds && this.infoToFilter.faceListSelecteds.length){
						let temp=[];
						this.infoToFilter.faceListSelecteds.forEach((x,idx)=> {
							if(x?.data?.length){
								x.data.forEach(z=>{
									if(x.selections.includes(z.uuid)){
										temp.push({
											list: x.name,
											person: z.uuid,
											personName : z.name,
											path: z.face_cropping,
										})
									}
								})
							}
						})
						info_up.list=temp;
					}
					if(this.infoToFilter.videosSelected/* && this.infoToFilter.videosSelected.length*/){
						info_up.uuid = info_up.uuid.concat(
							//.map(x=>{
							//return 
							[{
								type: "videodb",
								uuid: this.infoToFilter.videosSelected?.uuid || this.infoToFilter.videosSelected?.requestUuid,  
								
							}]
							)
						//})

				 		
					}
					if(this.infoToFilter.deviceSelecteds && this.infoToFilter.deviceSelecteds.length){
						info_up.uuid = info_up.uuid.concat(this.infoToFilter.deviceSelecteds.map(x=>{
							let dates1 = this.$Format.format_date_picker(x?.range?.dates);
							let datess = this.$Format.format_date_time(dates1,{
									start : x?.range?.start || '00:00',
									end : x?.range?.end || '23:59'
								}, true, false);
							return {
								type: "device",
								uuid: x.deviceId,
								interval : [datess?.start, datess?.end],
							}
						}))
					}
					const uri=this.$URL+"/api/v1/face_search";
					this.infoToFilter.results=[];
					// console.log("SEARCH ")
					await this.$axios.post(uri, info_up).then(async (res)=>{
						if(res?.data && res.data.length){
							const tempSimilarity=this.infoToFilter.similarity?(this.infoToFilter.similarity/100):0;
							let maxSimilarityFound = 0;
							
							this.infoToFilter.results=res.data.map(x=> {
								
								x.data = x.data.map(z=>{
									z.isVideoLoaded=false
									z.timestamp=new Date().getTime()	
									return z
								})
								
								
																
								//const tempList= x.data.sort((a,b)=> a.currentTime-b.currentTime).filter(x=> x.currentTime)
								const tempList = x.data.sort((a,b) => a.currentTime - b.currentTime).filter(x => x.currentTime !== undefined && x.currentTime !== null && !isNaN(x.currentTime))

						        const groupBySeconds = tempList.reduce((acc, item) => {
						          const segundo = Math.floor(item.currentTime); // Tomar el segundo entero
								  // console.log(segundo)
						          if (!acc[segundo]) {
						            acc[segundo] = [];
						          }
						          acc[segundo].push(item);
						          return acc;
						        }, {});
						        const tempData=[];
						        for (const [segundo, items] of Object.entries(groupBySeconds)) {
						          const maxItem = items.reduce((max, current) => 
						            current.similarity >= max.similarity ? current : max
						          );
						          tempData.push(maxItem)
						        }
								// console.log(info_up, 'aqui')
						        const find = info_up?.list?.length ? info_up.list.find(z => z.person == x?.uuid) : "";
						        if(find){
						        	x.name = `${find?.list} - ${find?.personName}`;
						        }
						        if(!x.name){
						        	x.name = info_up?.faces.length ? info_up?.faces.find(z=>z.photo_uuid==x?.uuid)?.name : "";
						        } 
								// x.videoBlob = await this.$Helper.loadVideoBlob(tempData[0]?.infovideo?.url)
						        x.data=tempData;
						        x.dataFilter=tempSimilarity >= 0?tempData.filter(it=> it.similarity>=tempSimilarity) : tempData
								
						        // console.log("DATA FILTER ", x.dataFilter, tempSimilarity, this.infoToFilter.similarity, tempData.filter(it=> it.similarity>=tempSimilarity)) 
								// x.maxProb = Math.max(...x.data.map(d => d.similarity));						
								x.maxProbData=x.data.reduce((max, obj) => obj.similarity > max.similarity ? obj : max, x.data[0]);
								x.maxProb=x.maxProbData.similarity;
								
								// Actualizar el máximo similarity encontrado
								if(x.maxProb > maxSimilarityFound) {
									maxSimilarityFound = x.maxProb;
								}
								
								return x
							});
							
							// Verificar si hay resultados que superen el similarity establecido
							const hasResultsAboveThreshold = this.infoToFilter.results.some(result => 
								result.dataFilter && result.dataFilter.length > 0
							);
							
							// Notificar al usuario sobre el resultado de la búsqueda
							if(hasResultsAboveThreshold) {
								this.$EventBus.$emit("notifications_modal", { 
									type: "success", 
									message: this.$ml.get('face_search_completed_successfully')
								});
							} else if(maxSimilarityFound > 0) {
								// No hay resultados que superen el threshold, pero sí se encontraron caras
								const maxSimilarityPercent = maxSimilarityFound * 100;
								const maxSimilarityDisplay = parseFloat(maxSimilarityPercent.toFixed(1)); // Mostrar al usuario con 1 decimal
								const adjustedSimilarity = Math.max(0, maxSimilarityPercent - 1); // Ajustar a 1 punto menos internamente
								this.$EventBus.$emit("notifications_modal", { 
									type: "warnining_dialog", 
									ID: "face_search_similarity_adjustment",
									message: this.$ml.with('similarity', maxSimilarityDisplay).get('no_results_above_similarity_threshold'),
									Action: (confirm) => {
										if(confirm) {
											this.infoToFilter.similarity = adjustedSimilarity; // Internamente usa el valor ajustado
											// Forzar la actualización de los datos filtrados
											this.$nextTick(() => {
												this.renderSimilarityAfterAdjustment();
											});
											this.$EventBus.$emit("notifications_modal", { 
												type: "success", 
												message: this.$ml.with('similarity', maxSimilarityDisplay).get('similarity_filter_adjusted')
											});
										}
									}
								});
							} else {
								// No se encontraron caras en absoluto
								this.$EventBus.$emit("notifications_modal", { 
									type: "info", 
									message: this.$ml.get('no_faces_found_in_search')
								});
							}
							
							this.infoToFilter.videoUrlPreload=this.infoToFilter.videosSelected?.file ? URL.createObjectURL(this.infoToFilter.videosSelected.file) : this.infoToFilter.videosSelected?.urlVideoPreload ? this.infoToFilter.videosSelected.urlVideoPreload : this.$URL + this.infoToFilter.videosSelected.url;
					 		// this.infoToFilter.videosSelected?.urlVideoPreload ? this.infoToFilter.videosSelected.urlVideoPreload : await this.$Helper.loadVideoBlob(this.infoToFilter.videosSelected.url);
							
							// this.infoToFilter.results=
						}else{
							this.infoToFilter.results=[];
							this.$EventBus.$emit("notifications_modal", { type : "success", message: this.$ml.get('no_data_found_face_search')})
						}
					}).catch(error=>{						
						console.warn("Error2  get search ", error)
					})
				}catch(error){
					console.warn("Error get search ", error)
				}finally{
					this.loading=false
					this.infoToFilter.loadingVideo=false;
				}
			},
			renderSimilarityAfterAdjustment(){
				// Método para actualizar los datos filtrados después de ajustar el similarity
				if(this.infoToFilter?.results && this.infoToFilter.results.length){
					const percent = (this.infoToFilter.similarity / 100);
					this.infoToFilter.results.forEach(x => {
						if(x.data && x.data.length){
							x.dataFilter = x.data.filter(item => item.similarity >= percent);
						}
					});
				}
			},
			renderTest(){
				let info_up= {uuid:[], faces:[]};
				if(this.infoToFilter.tagsSelected && this.infoToFilter.tagsSelected.length){
					info_up.faces=this.infoToFilter.tagsSelected.map((x,idx)=> {
						return {
							path : x.path || x.imgBase64,
							photo_uuid :  idx == 0 ? "f8b90666-fa22-474b-8f26-56d7036d5307" : x.uuid,
				     		top_n: idx,
				     		name : x.name,
						}
					})
				}
				if(this.infoToFilter.faceListSelecteds && this.infoToFilter.faceListSelecteds.length){
					let temp=[]
					this.infoToFilter.faceListSelecteds.forEach((x,idx)=> {
						if(x && x.data && x.data.length){
							x.data.forEach(z=>{
								if(x.selections.includes(z.uuid)){
									temp.push({
										list: x.name,
										person: idx == 0? "601fa3ca-6289-4313-9b57-c0a65036cef1" : z.uuid,
										path: z.face_cropping,
									})
								}
							})
						}
					})
					info_up.list=temp;
				}
				const tempSimilarity=this.infoToFilter.similarity?(this.infoToFilter.similarity/100):0;
				this.infoToFilter.results=testResult.map(x=> {
					x.data = x.data.map(z=>{
						z.isVideoLoaded=false
						z.timestamp=new Date().getTime()	
						return z
					})								
					const tempList= x.data.sort((a,b)=> a.currentTime-b.currentTime).filter(x=> x.currentTime)
			        const groupBySeconds = tempList.reduce((acc, item) => {
			          const segundo = Math.floor(item.currentTime); // Tomar el segundo entero
			          if (!acc[segundo]) {
			            acc[segundo] = [];
			          }
			          acc[segundo].push(item);
			          return acc;
			        }, {});
			        const tempData=[];
			        for (const [segundo, items] of Object.entries(groupBySeconds)) {
			          const maxItem = items.reduce((max, current) => 
			            current.similarity > max.similarity ? current : max
			          );
			          tempData.push(maxItem)
			        }
			        x.name = info_up?.list.length ? info_up.list.find(z=>z.person==x?.uuid)?.list : ""			        
			        if(!x.name){
			        	x.name = info_up?.faces.length ? info_up?.faces.find(z=>z.photo_uuid==x?.uuid)?.name : "";
			        } 
			        // console.log("NAME 2 ", x.name, info_up.list, info_up.list.find(z=>z.person==x.uuid), info_up.faces, x)

			        x.data=tempData;
					x.maxProb = Math.max(...x.data.map(d => d.similarity));						
			        x.dataFilter=tempSimilarity>=0?tempData.filter(it=> it.similarity>=tempSimilarity) : [] 
					return x
				});
			},
		}, //methods
	}
</script>